<template>
  <div class="order-item">
    <el-steps :active="active" finish-status="success">
      <el-step title="下单"></el-step>
      <el-step title="付款"></el-step>
      <el-step title="发货"></el-step>
      <el-step title="收货"></el-step>
      <el-step title="完成"></el-step>
    </el-steps>
    <div class="mb-30">
      <div class="d-flex mt-30 wall">
        <div class="d-flex color-sliver pt-10">
          <div>订单号：{{ orderInfo.order_id }}</div>
          <div v-if="orderInfo.cuser" class="ml-20">买家：{{ orderInfo.cuser.nick_name || orderInfo.cuser.username}}</div>
        </div>
        <div class="ml-auto">
          <el-button
            @click="dialogFormVisible = true"
            type="success"
            v-if="orderInfo.status == 'unsend'"
            round
          >发货</el-button>
        </div>
      </div>

      <el-row :gutter="30" class="mt-30">
        <el-col :span="12">
          <div class="wall">
            <div class="wall-head">订单详情</div>
            <div class="mt-10 p-15 info-item">
              <div class="mt-10">
                订单状态：
                <span class="color-primary" v-if="orderInfo.status === 'unpaid'">待付款</span>
                <span class="color-green" v-if="orderInfo.status === 'unsend'">待发货</span>
                <span v-if="orderInfo.status === 'unreceived'">待收货</span>
                <span v-if="orderInfo.status === 'finished'">已完成</span>
                <span v-if="orderInfo.status === '5'">退款中</span>
                <span v-if="orderInfo.status === 'cancel'">已关闭</span>
              </div>
              <div class="mt-10">
                买家留言：
                <span class="color-sliver">{{ orderInfo.user_note || '无' }}</span>
              </div>
              <div>
                卖家备注：
                <span class="color-sliver mr-10">{{ orderInfo.shop_note || '无' }}</span>
                <el-button type="text" @click="handleEditNote">编辑</el-button>
              </div>
              <div>
                支付方式：
                <span v-if="orderInfo.pay_method == 'wxpay'">微信支付</span>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="wall">
            <div class="wall-head">
              <span class="mr-20">收货地址</span>
              <el-button v-if="canEditAddress" type="text" @click="handleEditAddress">编辑</el-button>
            </div>
            <div class="info-item">
              <div class="mt-10">收货人：{{ orderInfo.receiver_name }}</div>
              <div class="mt-10">联系方式：{{ orderInfo.receiver_phone }}</div>
              <div class="mt-10">
                联系地址：
                {{ orderInfo.receiver_province }}
                {{ orderInfo.receiver_city }}
                {{ orderInfo.receiver_district }}
                {{ orderInfo.receiver_place }}
              </div>
              <div class="mt-20">身份证姓名：{{ orderInfo.card_name }}</div>
              <div class="mt-10">身份证号码：{{ orderInfo.card_code }}</div>
            </div>
          </div>
        </el-col>
        <el-col :span="24" v-if="hasShipping">
          <div class="wall mt-30">
            <div class="wall-head">物流信息</div>
            <div class="mt-10 p-15 container">
              <div class="d-flex">
                <div>物流单号：</div>
                <div>{{ shipper.LogisticCode }}</div>
                <div @click="dialogFormVisible = true" class="pointer color-primary ml-10">修改</div>
              </div>
              <div class="d-flex mt-10">
                <div>物流公司：</div>
                <div>{{ getShipperNameByCode(shipper.ShipperCode) }}</div>
              </div>
              <div v-if="shipper.Traces && shipper.Traces.length > 0" class="shipping"> 
                <el-timeline>
                  <el-timeline-item
                    v-for="(activity, index) in shipper.Traces"
                    :key="index"
                    class="fs-12"
                    :timestamp="activity.AcceptTime">
                    {{activity.AcceptStation}}
                  </el-timeline-item>
                </el-timeline>
              </div>
              <div v-else class="mt-10 color-sliver">暂无物流信息</div>
            </div>
          </div>
        </el-col>
      </el-row>

      <div class="wall mt-30">
        <div class="wall-head">订单明细</div>
        <div class="mt-10 p-15">
          <table class="order-table" border="0" cellspacing="0" cellpadding="0">
              <tr  class="head">
                <td>商品</td>
                <td align="center">单价</td>
                <td align="center">数量</td>
                <td align="center">退款状态</td>
                <td align="center">总额</td>
              </tr>
              <tr v-for="(good, gIndex) in orderInfo.skus" :key="gIndex">
                <td class="pt-10 pb-10" style="width: 320px;">
                  <div class="d-flex">
                    <img :src="good.sku.picture" alt="" style="width: 80px; height: 80px;">
                    <div class="p-10 flex-body" style="width: 220px;">
                      <div class="clamp">{{ good.sku.title }}</div>
                      <div class="mt-auto">{{ good.sku.specs|obj_to_string }}</div>
                    </div>
                  </div>
                </td>
                <td align="center">
                  <span class="text-price">{{ good.sku.shop_price }}</span>
                </td>
                <td align="center">{{ good.count }}</td>
                <td align="center">
                  <span :style="{color:statusObj[good.aftersale_status].color}">{{statusObj[good.aftersale_status].text}}</span>
                </td>
                <td align="center">
                  <div class="text-price">{{ good.price }}</div>
                  <div class="mt-10">福利券抵扣：<span class="text-price">{{ Math.ceil(good.welfare_amount) }}</span></div>
                </td>
              </tr>
          </table>
          <div class="mt-35 amount-list">
            <div class="item fs-12">
              <div class="label">金额：</div>
              <span class="text-price">{{ orderInfo.total_amount }}</span>
            </div>
            <div class="item fs-12">
              <div class="label">福利券抵扣：</div>
              <span class="text-price">{{ orderInfo.pay_welfare }}</span>
            </div>
            <div class="item">
              <div class="label">合计：</div>
              <span class="text-price">{{ orderInfo.pay_amount }}</span>
            </div>
          </div>
        </div>

        <!-- <div class="color-black mt-30 welfare_title">订单历史</div>
        <div class="mt-10 p-15 container">
          <ul class="color-sliver">
            <li class="mt-10">下单：2020-01-01 12:12:12</li>
            <li class="mt-10">付款：2020-02-02 12:12:12</li>
            <li class="mt-10">发货：2020-02-02 12:13:14</li>
            <li class="mt-10">收货：2020-04-01 12:12:23</li>
          </ul>
        </div> -->
      </div>
    </div>

    <!-- 物流信息 -->
    <el-dialog title="物流信息" :visible.sync="dialogFormVisible" width="460px">
      <rs-form :errors="shipperError" :model="formShipping" label-width="80px">
        <el-form-item label="物流公司" prop="shipper_code" required>
          <el-select filterable v-model="formShipping.shipper_code" placeholder="请选择物流公司">
            <el-option
              v-for="(item, index) in shippingData"
              :key="index"
              :label="item.name"
              :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="物流单号"
          prop="logistic_code"
          required
          :rules="[{ required: true, message: '请填写物流单号', trigger: 'blur' }]"
        >
          <el-input v-model="formShipping.logistic_code" autocomplete="off"></el-input>
        </el-form-item>
      </rs-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" :loading="shippingBtnLoading" @click="handleShipper">确 定</el-button>
      </div>
    </el-dialog>

    <address-dialog ref="addressDialog" @on-success="loadOrderInfo"/>
  </div>
</template>

<script>
import {
  getOrderInfo,
  createShipper,
  updateLogistic,
  getShipper,
  getShipperList,
  updateShopNote
} from '@/api/order.js';
import { setShippingCode, getShippingCode } from '@/utils/auth';
import AddressDialog from './components/AddressDialog.vue';

export default {
  components: { AddressDialog },
  data() {
    return {
      active: 1,
      hasShipping: false,
      orderId: this.$route.query.order_id,
      orderInfo: {
        cuser: {},
        address: {},
        skus: []
      },
      dialogFormVisible: false,
      shippingBtnLoading: false,
      formShipping: {
        shipper_code: null,
        logistic_code: null
      },
      shipper: {}, // 物流信息
      shipperError: {}, // 发货错误信息
      shippingData: [],
      statusObj:{
        unapply:{text:'暂无',color:'#999999'},
        unaudited:{text:'待商家处理',color:'#67C23A'},
        processing: {text:'处理中',color:'#67C23A'},
        cancel: {text:'已取消',color:'#999999'},
        refused: {text:'已拒绝',color:'#ED4645'},
        refunded: {text:'已退款',color:'#999999'},
        returned: {text:'已退货',color:'#999999'}
      } // 物流公司列表
    };
  },
  created() {
    getShipperList().then(res => {
      this.shippingData = res || [];
    })
    // 获取订单列表
    this.loadOrderInfo();
    this.formShipping.shipper_code = getShippingCode()
  },
  computed:{
    isUnsend(){
      return this.orderInfo.status === 'unsend'
    },
    canEditAddress() {
      return this.orderInfo.status === 'unpaid' || this.orderInfo.status === 'unsend'
    }
  },
  methods: {
    handleEditAddress() {
      this.$refs.addressDialog && this.$refs.addressDialog.show(this.orderInfo);
    },
    // 获取订单信息
    async loadOrderInfo() {
      const res = await getOrderInfo(this.orderId);
      if (!res) this.$router.go(-1);
      this.orderInfo = res;

      // 设置当前进度条状态
      switch(res.status) {
        case 'unpaid' : this.active = 0; this.hasShipping = false; break;
        case 'unsend' : this.active = 1; this.hasShipping = false; break;
        case 'unreceived' : this.active = 2; this.hasShipping = true; break;
        case 'uncomment' : this.active = 3; this.hasShipping = true; break;
        case 'finished' : this.active = 5; this.hasShipping = true; break;
        case 'cancel' : this.active = 6; this.hasShipping = false; break;
        default: this.active = 4; this.hasShipping = true;
      }

      if (this.active > 1 && this.active < 6) {
        // 获取物流信息
        this.loadShipper();
      }
    },
    // 获取物流信息
    async loadShipper() {
      const res = await getShipper(this.orderId);

      this.shipper = res;
      this.shipper.Traces = res.Traces.reverse()

      this.formShipping = {
        shipper_code: res.ShipperCode || null,
        logistic_code: res.LogisticCode || null
      }
    },
    // 发货 or 修改物流信息
    async handleShipper() {
      this.shippingBtnLoading = true;
      // 保存历史物流
      setShippingCode(this.formShipping.shipper_code);
      try {
        if(this.isUnsend){
          await createShipper(this.orderId, this.formShipping)
        }else{
          await updateLogistic(this.orderId, this.formShipping)
        }
        this.shippingBtnLoading = false;
        this.dialogFormVisible = false;
        this.$message.success(this.isUnsend?'发货成功':'修改成功');
        this.loadOrderInfo();
        this.loadShipper();
      }
      catch(err){
        this.shipperError = err.data || {};
        this.shippingBtnLoading = false;
      }
    },
    // 修改备注信息
    handleEditNote() {
      this.$prompt('备注', '修改备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: this.orderInfo.suser_note
      }).then(({ value }) => {
        // 修改备注
        updateShopNote(this.orderId, { shop_note: value }).then(() => {
          this.loadOrderInfo();
        })
      }).catch(() => {});
    },
    getShipperNameByCode(code) {
      var item = this.shippingData.filter(s => {
        return s.code === code;
      }) || []
      if (item.length == 0) return '无物流公司';
      return item[0].name;
    }
  }
}
</script>

<style scoped lang="scss">
.order-table {
  width: 100%;
  font-size: 12px;
  color: $black;
  .head {
    background-color: rgba(255,125,98,0.06);
    color: $lightGray;
    td {
      padding: 10px 5px;
      border: none;
    }
  }
}
.info-item {
  height: 118px;
}
.shipping {
  max-height: 128px;
  margin-top: 10px;
  padding-top: 10px;
  overflow-y: scroll;
}
.amount-list {
  .item {
    text-align: right;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
    .text-price {
      width: 80px;
      text-align: left;
    }
  }
}
.order-item {
  ::v-deep .el-steps {
    background: #fafafa;
    border-radius: 4px;
    overflow: hidden;
    padding: 0;
    .el-step {
      width: 19.999999%;
    }
    .el-step__description,
    .el-step__head {
      display: none;
    }
    .el-step__main {
      position: relative;
    }
    .el-step__title {
      width: 100%;
      padding: 6px 0;
      text-align: center;
    }
    .el-step__title.is-success,
    .el-step__title.is-process {
      background: $orange;
      color: #fff;
    }
    .el-step__title.is-process::after {
      position: absolute;
      right: 0;
      top: 0;
      content: ' ';
      width: 0;
      height: 0;
      border-top: 25px solid transparent;
      border-right: 13px solid #fafafa;
      border-bottom: 25px solid transparent;
    }
  }
}
</style>
